
import { defineComponent } from 'vue';

export default defineComponent({
	props: {
		allLabel: {
			type: String,
			default: 'Cả trung tâm',
		},
	},

	data() {
		return {
			isAll: true,
		};
	},

	methods: {
		close() {
			this.$emit('close');
		},
	},
});
